export default {
  editLocation: 'Edytuj lokalizację',
  businessHours: 'Godziny pracy',
  closed: 'Zamknięte',
  loadError: 'Nie udało się wczytać lokalizacji',
  retry: 'Spróbuj ponownie',
  saveError: 'Nie udało się zapisać lokalizacji',
  shiftsNotSaved: 'Strefa czasowa została zapisana, ale godziny pracy nie',
  notMaintained: 'Nie określono godzin pracy, więc lokalizacja jest uznawana za obsadzoną przez całą dobę.',
  shifts: 'Zmiany',
  shiftsHint: 'Nazwy zmian tej lokalizacji. Ich godziny ustala się poniżej dla każdego dnia.',
  addShift: 'Dodaj zmianę',
  newShiftDisplayName: 'Zmiana {number}',
  shiftInUse: 'Najpierw usuń okna tej zmiany',
  invalidShiftDisplayName: 'Każda zmiana potrzebuje nazwy, której nie ma żadna inna zmiana tej lokalizacji.',
  businessHoursHint: 'Przeciągnij w obrębie dnia, aby dodać okno, i przeciągnij jego uchwyty, aby zmienić godziny. Wybierz okno, aby wpisać godziny lub zmienić zmianę. Okno kończące się przed rozpoczęciem kończy się następnego dnia.',
  addShiftToDay: 'Dodaj zmianę do: {day}',
  noShift: 'Dodaj zmianę powyżej, aby dodać okna.',
  allShiftsUsed: 'Każda zmiana ma już okno w dniu: {day}.',
  overlappingWindow: 'Okna nie mogą się nakładać, także z oknem następnego dnia.',
  continuedFrom: '{shift} (od: {day})',
  timezoneChanged: {
    summary: 'Strefa czasowa zostanie zmieniona',
    details: 'Czasy tej lokalizacji będą wyświetlane w nowej strefie czasowej. Godziny pracy zachowują swój czas lokalny.',
  },
  copy: {
    workdays: 'Kopiuj na poniedziałek–piątek',
    allDays: 'Kopiuj na wszystkie dni',
  },
};
